import React from 'react';
import {IShipment} from "../../../../../../../../../app/interfaces/shipment/IShipment";
import ForwarderField
    from "../../../../../../../../../components/shared/form/detailsFields/ForwarderField/ForwarderField";

type TransportPlannerProps = {
    shipment: IShipment
}

const TransportPlanner: React.FC<TransportPlannerProps> = ({
                                                             shipment
                                                         }) => {
    return (
        <div className={'details-box-field-value'}>
            {shipment.transportPlanner !== null && shipment.transportPlanner !== undefined && shipment.transportPlanner.name !== null && shipment.transportPlanner.name !== ''
                ? <ForwarderField user={shipment.transportPlanner}
                                  chatReplyTo={{
                                      type: 'SHIPMENT',
                                      id: shipment.orderReleaseGid?.replace('AAG.', '') ?? '',
                                      idExt: shipment.shipmentGid,
                                      description: shipment.chatDescription
                                  }}/>
                : null
            }
        </div>
    );
};

export default TransportPlanner;